/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Work_NobodyInputs */

const vi_station_work_nobody = /** @type {(inputs: Station_Work_NobodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa giao ai`)
};

/**

* @param {Station_Work_NobodyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_nobody = /** @type {((inputs?: Station_Work_NobodyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_NobodyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_nobody(inputs)
});